import React from 'react';
import { Shield, TrendingUp, Users, Zap } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Overview = () => {
  const benefits = [
    {
      icon: Shield,
      title: 'Transparansi Transaksi',
      description: 'Semua transaksi tercatat dengan jelas dan dapat dilacak secara real-time oleh semua pihak yang berwenang.',
    },
    {
      icon: TrendingUp,
      title: 'Pengelolaan Saldo Terpusat',
      description: 'Sistem manajemen saldo digital yang terintegrasi untuk nasabah, petugas, dan rekanan dalam satu platform.',
    },
    {
      icon: Zap,
      title: 'Efisiensi Operasional',
      description: 'Otomatisasi proses pencatatan dan distribusi dana menghemat waktu dan mengurangi kesalahan manual.',
    },
    {
      icon: Users,
      title: 'Ekosistem Daur Ulang',
      description: 'Mendukung kolaborasi antara nasabah, petugas, lapak, dan rekanan untuk ekonomi sirkular yang berkelanjutan.',
    },
  ];

  return (
    <section id="overview" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6 bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300 bg-clip-text text-transparent">
            Manfaat Utama Aplikasi
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-3xl mx-auto">
            Dirancang untuk memberikan solusi komprehensif dalam pengelolaan sampah dan transaksi keuangan yang efisien
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <Card
              key={index}
              className="group border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:shadow-2xl hover:border-emerald-500 dark:hover:border-emerald-500 transition-all duration-300 hover:-translate-y-2"
            >
              <CardContent className="p-8">
                <div className="flex items-start space-x-4">
                  <div className="bg-gradient-to-br from-emerald-500 to-teal-600 w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <benefit.icon className="h-7 w-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
                      {benefit.title}
                    </h3>
                    <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Overview;